import { render } from "./IconChevronDown.vue?vue&type=template&id=5cc1269e"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconChevronDown.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5cc1269e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5cc1269e', __exports__)) {
    api.reload('5cc1269e', __exports__)
  }
  
  module.hot.accept("./IconChevronDown.vue?vue&type=template&id=5cc1269e", () => {
    api.rerender('5cc1269e', render)
  })

}


export default __exports__